<template>
  <div id="captcha"></div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
const { container } = defineProps(['container']);
const emit = defineEmits(['success']);
const captcha = ref(null)
const data = ref(null)
const success = ref(false)

const init = () => {
  if (captcha.value) {
    (captcha.value as any).reset();
    data.value = null;
    success.value = false;
    return;
  }

  let width = 400;
  let height = 48;

  const el = document.querySelector(container);
  if (el) {
    width = parseInt(window.getComputedStyle(el).width);
    height = parseInt(window.getComputedStyle(el).height);
  }

  // @ts-ignore
  // eslint-disable-next-line no-undef
  AWSC.use('ic', function(state, module) {
    captcha.value = module.init({
      width,
      height,
      // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
      appkey: 'FFFF0N0000000000A60B',
      //使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
      scene: 'register',
      // 声明滑动验证需要渲染的目标ID。
      renderTo: 'captcha',
      //前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
      success: function (data: any) {
        data.value = data;
        success.value = true;
        emit('success', data);
      },
      // 滑动验证失败时触发该回调参数。
      fail: function (failCode: string) {
        success.value = false;
        window.console && console.log(failCode);
        // emit('fail', failCode);
      },
      // 验证码加载出现异常时触发该回调参数。
      error: function (errorCode: string) {
        success.value = false;
        window.console && console.log(errorCode);
        // emit('error', errorCode);
      },
    })
  })
}

onMounted(() => {
  init();
})

defineExpose({init})
</script>

<style lang="scss">
#captcha {
  height: 48px;
  .sm-btn {
    border-radius: 6px;
  }
  .sm-txt {
    vertical-align: unset;
  }
  .sm-pop {
    width: 100% !important;
    inset: 0px !important;
    height: 48px !important;
    line-height: 48px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
  }
  .shield {
    top: 10px;
  }
  .sm-btn-success {
    #rectMask {
      .rect-top {
        display: none;
      }
      .rect-bottom {
        display: none;
      }
    }
  }
  .nc-container {
    inset: 0px !important;
    .nc_wrapper {
      width: 100%;
      height: 46px;
      .nc_scale {
        height: 100%;
        .btn_slide {
          height: 46px;
          line-height: 46px;
          border-radius: 6px;
        }
        .scale_text {
          .nc-lang-cnt {
            line-height: 46px;
          }
        }
        .btn_ok {
          height: 46px;
          line-height: 46px;
          border-radius: 6px;
        }
      }
    }
  }
}
</style>

